var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPad-768-Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-300 -592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevrons",
    transform: "translate(301 199)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M10 393.06l-5 5-5-5"
  })))));
}
SvgArrow.displayName = 'Arrow';
export default SvgArrow;